let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8ajEA")).then(() => parcelRequire('c8vxa'));